import { useCurrentWorkspace } from '@/context/current-workspace';
import { hasFeatureFlag } from '@/services/auth/feature-flags';
import { useSampleWorkspace } from '@/utils/sample-workspace';
import { PlainLink, Strong, Text } from '@customerio/pluma-components/react';
import { useStore } from '@nanostores/react';
import * as styles from './index.css';
import { authStore } from '@/services/auth/store';

/**
 * Sample workspace components that show visual indicators when viewing the sample workspace
 */

export function SampleWorkspaceBadge() {
  const auth = useStore(authStore);
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  if (!(hasFeatureFlag('interactive_demo_workspace') || hasFeatureFlag('sample_workspace'))) {
    return null;
  }

  if (!isSampleWorkspace(workspace?.id)) {
    return null;
  }

  return (
    <div>
      <div className={styles.sampleWorkspaceBadge}>
        <Text color="inherit">
          You're currently viewing the <Strong>Sample Workspace.</Strong> Switch to{' '}
          <PlainLink href={`/workspaces/${auth.user?.last_cio_workspace_id}`} textDecoration="underline">
            my workspace
          </PlainLink>
          .
        </Text>
      </div>
    </div>
  );
}

/**
 * Sample workspace border that shows a border around the entire page when the user
 * is viewing the sample workspace.
 */
export function SampleWorkspaceBorder() {
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  if (!(hasFeatureFlag('interactive_demo_workspace') || hasFeatureFlag('sample_workspace'))) {
    return null;
  }

  if (!isSampleWorkspace(workspace?.id)) {
    return null;
  }

  return <div className={styles.sampleWorkspaceBorder} />;
}
